import fixRotationStore from '@modules/fixRotation/store/fixRotationStore';

const useFixRotationStore = () => {
  const fixRotationService = fixRotationStore((state) => state.fixRotationService);
  const setFixRotationService = fixRotationStore((state) => state.setFixRotationService);
  const rotationPhase = fixRotationStore((state) => state.rotationPhase);
  const setRotationPhase = fixRotationStore((state) => state.setRotationPhase);
  const upperJawMesh = fixRotationStore((state) => state.upperJawMesh);
  const setUpperJawMesh = fixRotationStore((state) => state.setUpperJawMesh);
  const lowerJawMesh = fixRotationStore((state) => state.lowerJawMesh);
  const setLowerJawMesh = fixRotationStore((state) => state.setLowerJawMesh);
  const reset = fixRotationStore((state) => state.reset);

  return {
    fixRotationService,
    setFixRotationService,
    rotationPhase,
    setRotationPhase,
    upperJawMesh,
    setUpperJawMesh,
    lowerJawMesh,
    setLowerJawMesh,
    reset,
  };
};

export default useFixRotationStore;
